import React from 'react';
import './Header.css';

export default function Header (props: { menuOpen: boolean }) {
  return (
    <header className="header">
      <picture>
        <source media="(max-width: 768px)" srcSet="/images/Header1.avif" />
        <source media="(min-width: 769px)" srcSet="/images/Header1-3.avif" />
        <img src="/images/Header1.avif" className="header-image" alt="sheep-header" />
      </picture>
      <div className="header-content">
        <nav className={`header-button-container ${props.menuOpen ? 'open' : ''}`}>
          <ul className='nav-list'>
            <li><a href="/">Home</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}